var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { version } from "../package.json";
var WebsailLoader = /** @class */ (function () {
    function WebsailLoader(config) {
        var _this = this;
        var _a;
        this.VERSION = process.env.VERSION || version;
        this.args = [];
        this.constructorArgs = [];
        this.isAdmin = false;
        this.onLoadBundle = function () {
            for (var _i = 0, _a = _this.constructorArgs; _i < _a.length; _i++) {
                var constructorArgs = _a[_i];
                var integration = new window.wsBundleIntegration(constructorArgs);
                _this.isAdmin
                    ? integration.initAdmin()
                    : integration.init.apply(integration, (_this.args.shift() || []));
                integration.initAdmin = function () { };
            }
            _this.init(_this.args.shift());
        };
        this.loadScripts = function (config) {
            if (config === void 0) { config = {}; }
            if (!config.apiBaseUrl) {
                return;
            }
            if (window.websailBundle) {
                return;
            }
            var basePath = config.apiBaseUrl;
            if (basePath.indexOf("?") >= 0) {
                basePath = basePath.slice(0, basePath.indexOf("?"));
            }
            var filePath = new URL("bee-react-form/bundle.min.js", basePath).href;
            filePath += "?v=" + _this.VERSION;
            var sNew = document.createElement("script");
            sNew.onload = _this.onLoadBundle;
            sNew.async = true;
            sNew.src = filePath;
            document.body.append(sNew);
            // loaderScript.insertAdjacentElement("afterend", sNew);
        };
        this.init = function (config) {
            if (!config) {
                return;
            }
            _this.loadScripts(config);
            var websailBundle = window.websailBundle;
            if (websailBundle) {
                _this.args.push(config);
                websailBundle.init(_this.args.shift());
                return;
            }
            _this.args.push(config);
        };
        if ((config === null || config === void 0 ? void 0 : config.loader) !== true) {
            if (window.wsBundleIntegration) {
                return new window.wsBundleIntegration(config);
            }
            this.constructorArgs.push(config);
        }
        var websailConfig = ((_a = window.websailConfig) !== null && _a !== void 0 ? _a : {});
        if ("apiBaseUrl" in websailConfig)
            this.args.push(websailConfig);
        this.loadScripts(__assign(__assign({}, config), websailConfig));
    }
    WebsailLoader.prototype.initAdmin = function () {
        this.isAdmin = true;
    };
    return WebsailLoader;
}());
window.wsintegration = WebsailLoader;
window.websail = new WebsailLoader({ loader: true });
export default {};
